import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { EmojiEvents, Save } from "@material-ui/icons";

import { gradeSchoolLevel } from "../../../../reducer/studentResearch/action";
import { SCHOOL_LEVEL_RESULT_OPTIONS, CONFERENCE_RESULT_PARTICIPATE } from "../../../../constants/projectStatus";
import SectionCard from "../../utils/SectionCard";
import LevelNoteField from "../../utils/LevelNoteField";

// SchoolLevelForm — Phòng QLKH chấm báo cáo cấp Trường. Chỉ hiển thị khi
// Trưởng khoa đã chấm cấp Khoa và đề xuất báo cáo tại HNSV (school_level_pending).
export default function SchoolLevelForm({ detail, onDone }) {
  const dispatch = useDispatch();
  const [prize, setPrize] = useState(detail?.schoolLevelPrize || CONFERENCE_RESULT_PARTICIPATE);
  const [comment, setComment] = useState(detail?.schoolLevelComment || "");
  const [note, setNote] = useState(detail?.schoolLevelNote || "");
  const [proposeNext, setProposeNext] = useState(!!detail?.schoolLevelEligible);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setPrize(detail?.schoolLevelPrize || CONFERENCE_RESULT_PARTICIPATE);
    setComment(detail?.schoolLevelComment || "");
    setNote(detail?.schoolLevelNote || "");
    setProposeNext(!!detail?.schoolLevelEligible);
  }, [detail?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async () => {
    setSaving(true);
    try {
      const ok = await dispatch(gradeSchoolLevel(detail.id, { prize, comment, note, proposeNext }));
      if (ok && onDone) onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<EmojiEvents />} title="Chấm báo cáo cấp Trường" marginTop={0}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              Xếp loại <span style={{ color: "#c62828" }}>*</span>
            </Typography>
            <Select
              fullWidth
              variant="outlined"
              margin="dense"
              value={prize}
              onChange={(e) => setPrize(e.target.value)}
            >
              {SCHOOL_LEVEL_RESULT_OPTIONS.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={proposeNext}
                  onChange={(e) => setProposeNext(e.target.checked)}
                />
              }
              label="Đề xuất báo cáo tại Hội nghị SVNCKH cấp quốc gia"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              Nhận xét
            </Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid>
          <LevelNoteField value={note} onChange={setNote} />
        </Grid>
      </SectionCard>

      <Box
        marginTop={3}
        paddingTop={2}
        display="flex"
        justifyContent="flex-end"
        borderTop="solid 1px #e0e0e0"
      >
        <Button
          variant="contained"
          color="primary"
          disabled={saving}
          onClick={handleSave}
          startIcon={<Save />}
        >
          Lưu kết quả cấp Trường
        </Button>
      </Box>
    </Box>
  );
}
